import script from "./OUsuarioInformacoes.vue?vue&type=script&lang=ts&setup=true"
export * from "./OUsuarioInformacoes.vue?vue&type=script&lang=ts&setup=true"

import "./OUsuarioInformacoes.vue?vue&type=style&index=0&id=1f9691eb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f9691eb"]])

export default __exports__